import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// images
import logo from 'assets/images/logo.svg';
import FeatherIcon from 'feather-icons-react';

const Footer = () => {

    const { t } = useTranslation();
    

    return (
        <section className="mt-lg-5 pt-5 pb-4 bg-gradient3 position-relative" style={{background: '#0055FF12'}}>
            <Container>
                <Row className="gy-4 gx-lg-5 align-items-start">
                    {/* Logo dan Deskripsi */}
                    <Col lg={5}>
                        <Link className="navbar-brand mb-3 d-flex align-items-center" to="#">
                            <img src={logo} height="30" alt="Logo Sanata System" />
                        </Link>
                        <p className="text-muted mb-0">
                            {t('footer.deskripsi')}
                        </p>
                    </Col>

                    {/* Info Kontak */}
                    <Col lg={5} className="offset-lg-2">
                        <h6 className="mb-3 fs-14 fw-semibold text-uppercase">{t('footer.info_kontak')}</h6>

                        <div className="d-flex mb-2 text-muted">
                            <FeatherIcon
                                icon="map-pin"
                                size={14}
                                style={{ flexShrink: 0 }}
                                className="me-2 mt-1"
                            />
                            <a
                                href="https://www.google.com/maps?q=Jl.+Kusuma+Bangsa+II+No.11,+Pemecutan+Kaja,+Denpasar"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-muted"
                            >
                                {t('footer.alamat')}
                            </a>
                        </div>


                        <div className="d-flex mb-2 text-muted">
                            <FeatherIcon
                                icon="mail"
                                size={14}
                                style={{ flexShrink: 0 }}
                                className="me-2 mt-1"
                            />

                            <span>{t('footer.email')}</span>
                        </div>

                        <div className="d-flex text-muted">
                            <FeatherIcon
                                icon="phone"
                                size={14}
                                style={{ flexShrink: 0 }}
                                className="me-2 mt-1"
                            />

                            <span>{t('footer.telepon')}</span>
                        </div>
                    </Col>
                </Row>

                <hr className="my-4" />

                <Row className="text-md-start text-center align-items-center">
                    <Col md={8}>
                        <p className="mb-0 text-muted">
                            © Copyright 2024. All right reserved by <strong>PT Sanata System</strong>
                        </p>
                    </Col>

                    <Col md={4} className="text-md-end mt-3 mt-md-0">
                        <ul className="list-unstyled mb-0 d-flex justify-content-md-end justify-content-center">
                            <li className="ms-3">
                                <a href="https://www.instagram.com/sanatasystem" className="text-muted" target="_blank" rel="noopener noreferrer">
                                    <FeatherIcon icon="instagram" className="icon icon-xs" />
                                </a>
                            </li>
                            <li className="ms-3">
                                <a href="https://www.facebook.com/sanatasystem" className="text-muted" target="_blank" rel="noopener noreferrer">
                                    <FeatherIcon icon="facebook" className="icon icon-xs" />
                                </a>
                            </li>
                            <li className="ms-3">
                                <a href="https://www.linkedin.com/company/sanata-system/" className="text-muted" target="_blank" rel="noopener noreferrer">
                                    <FeatherIcon icon="linkedin" className="icon icon-xs" />
                                </a>
                            </li>
                        </ul>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Footer;
